import styled from '@emotion/styled';

export const DateInputLegend = styled.legend`
  color: unset !important;
  font-size: unset !important;
  margin-bottom: unset !important;
  padding: unset !important;
  border: unset !important;
`;

export const DateInputPreview = styled.div`
  margin-bottom: 0.5em;
  font-size: 0.9em;
  color: #777;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DateInputItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 0.5em;

  input[name='day'],
  input[name='month'] {
    width: 6ch;
  }

  input[name='year'] {
    width: 8ch;
  }
`;
